import { Controller } from '@hotwired/stimulus';

export class AddressController extends Controller {
  static targets = [
    'country',
    'regionField',
    'regionTemplate',
    'provinceTemplate',
    'stateTemplate',
  ];

  updateFields(event) {
    let regionTemplate;

    switch (event.target.value) {
      case 'US':
        regionTemplate = this.stateTemplateTarget;
        break;
      case 'CA':
        regionTemplate = this.provinceTemplateTarget;
        break;
      default:
        regionTemplate = this.regionTemplateTarget;
        break;
    }

    this.regionFieldTarget.innerHTML = regionTemplate.innerHTML;
  }
}
